// 新项目请求
import axios from 'axios'
export const newPost = (url, data = {}, type) => {
  return new Promise((resolve, reject) => {
    axios({
      url,
      method: type ? type : 'post',
      headers: {
        'Content-Type': 'application/json;charset=utf-8',
        'X-Requested-With': 'XMLHttpRequest'
      },
      // 发送的数据
      data
    }).then(res => {
      resolve(res)
    })
  })
}

const newPostBlob = (url, data = {}, type) => {
  return new Promise((resolve, reject) => {
    axios({
      url,
      method: type ? type : 'post',
      responseType: "blob",
      withCredentials: true,
      headers: {
        "Content-Type": "application/json"
      },
      // 发送的数据
      data
    }).then(res => {
      resolve(res)
    })
  })
}



//二维码图片
export const qrCodeGet = (url, data = {}) => {
  return new Promise((resolve, reject) => {
    axios({
      url,
      method: 'get',
      headers: {
        'Content-Type': 'application/json;charset=utf-8',
        'X-Requested-With': 'XMLHttpRequest'
      },
      // 发送的数据
      params:data,
      responseType: 'blob'
    }).then(res => {
      resolve(res)
    })
  })
}


// 四舍五入 len为保留的小数位
export const toFixedRe = (num, s) => {
//   var times = Math.pow(10, s + 1),
//     des = parseInt(num * times),
//     rest = des % 10;
//   if (rest == 5) {
//     return ((parseFloat(des) + 1) / times).toFixed(s);
//   }
//   return num.toFixed(s);
    if(isNaN(num)) {
        console.error('Uncaught TypeError: ' + num + ' is not a number')
        return 0
    }
    let multiplier  = Math.pow(10, s)
    if(typeof num != 'number') {
        return 0
    }
    // let result = Math.round((num || 0)*multiplier )/multiplier 
    let result = Math.round(Number(((num || 0)*multiplier).toFixed(2)) )/multiplier
    return result
}

class XSet extends Set {
  union(...sets) {
    return XSet.union(this, ...sets)
  }
  intersection(...sets) {
    return XSet.intersection(this, ...sets);
  }
  difference(set) {
    return XSet.difference(this, set);
  }
  symmetricDifference(set) {
    return XSet.symmetricDifference(this, set);
  }
  cartesianProduct(set) {
    return XSet.cartesianProduct(this, set);
  }
  powerSet() {
    return XSet.powerSet(this);
  }
  // 返回两个或更多集合的并集
  static union(a, ...bSets) {
    const unionSet = new XSet(a);
    for (const b of bSets) {
      for (const bValue of b) {
        unionSet.add(bValue);
      }
    }
    return unionSet;
  }
  // 返回两个或更多集合的交集
  static intersection(a, ...bSets) {
    const intersectionSet = new XSet(a);
    for (const aValue of intersectionSet) {
      for (const b of bSets) {
        if (!b.has(aValue)) {
          intersectionSet.delete(aValue);
        }
      }
    }
    return intersectionSet;
  }
  // 返回两个集合的差集
  static difference(a, b) {
    const differenceSet = new XSet(a);
    for (const bValue of b) {
      if (a.has(bValue)) {
        differenceSet.delete(bValue);
      }
    }
    return differenceSet;
  }
  // 返回两个集合的对称差集
  static symmetricDifference(a, b) {
    // 按照定义，对称差集可以表达为
    return a.union(b).difference(a.intersection(b));
  }
  // 返回两个集合（数组对形式）的笛卡儿积
  // 必须返回数组集合，因为笛卡儿积可能包含相同值的对
  static cartesianProduct(a, b) {
    const cartesianProductSet = new XSet();
    for (const aValue of a) {
      for (const bValue of b) {
        cartesianProductSet.add([aValue, bValue]);
      }
    }
    return cartesianProductSet;
  }
  // 返回一个集合的幂集
  static powerSet(a) {
    const powerSet = new XSet().add(new XSet());
    for (const aValue of a) {
      for (const set of new XSet(powerSet)) {
        powerSet.add(new XSet(set).add(aValue));
      }
    }
    return powerSet;
  }
}

/**
 * @internal
 * @function 求两个数组的交集
 * @description 数组为简单数组
 * @returns {array} 正常的数组
 * */
const intersection = (aArray, bArray) => {
  const aArrayXSet = new XSet(aArray);
  const bArrayXSet = new XSet(bArray);
  const resultArray = aArrayXSet.intersection(bArrayXSet);
  return Array.from(resultArray);
}

/**
 * @internal
 * @function 求两个数组的并集
 * @description 数组为简单数组
 * @returns {array} 正常的数组
 * */
const union = (aArray, bArray) => {
  const aArrayXSet = new XSet(aArray);
  const bArrayXSet = new XSet(bArray);
  const resultArray = aArrayXSet.union(bArrayXSet);
  return Array.from(resultArray);
}

/**
 * @internal
 * @function 求两个数组的差集;数组aArray相对于bArray所没有的;注意：数组长度大的在前
 * @description 数组为简单数组
 * @returns {array} 正常的数组
 * */
const difference = (aArray, bArray) => {
  const aArrayXSet = new XSet(aArray);
  const bArrayXSet = new XSet(bArray);
  const resultArray = aArrayXSet.difference(bArrayXSet);
  return Array.from(resultArray);
}

/**
 * @function  获取集合运算的结果数组
 * @param {string/function} key 数组对象的唯一标识
 * @param {string} functionAction 需要调用的函数
 * @param {array} aArray
 * @param {array} bArray
 * @returns {array} 正常的数组
 * @example '并集 union',        getResultArray('id', 'u', aArray, bArray)
 * '交集 intersection', getResultArray('id', 'i', aArray, bArray)
 * '差集 difference',   getResultArray('id', 'd', aArray, bArray)
 * */
export const getResultArray = (key, functionAction, aArray, bArray) => {
  const aArraySimple = aArray.map(i => typeof key == 'function' ? key(i) : i[key]); // 根据唯一标识对象数组转换为简单数组
  const bArraySimple = bArray.map(i => typeof key == 'function' ? key(i) : i[key]);
  const allData = [...aArray, ...bArray];
  const resultArraySimple = Array.from(functionAction == 'u' ? union : (functionAction == 'i' ? intersection : difference)(aArraySimple, bArraySimple));
  return resultArraySimple.map(i => allData.find((j) => (typeof key == 'function' ? key(j) : j[key]) === i));
}

/**
 * @function  数组去重
 * @param {array} arr 要去重的数组
 * @param {string} key 唯一值
 * @returns {array} 去重后的数组
 */

export const unique = (arr, key = "value") => {
  const tempMap = new Map();
  return arr.filter(
    (item) => !tempMap.has(item[key]) && tempMap.set(item[key], 1)
  );
};

/**
 * 函数防抖
 * @example var setUseAction = debounce(getUserAction, 10000, true);  使用防抖 node.onmousemove = setUseAction  取消防抖 setUseAction.cancel()
 */
export function debounce(func, wait, immediate) {
  var timeout, result;

  var debounced = function () {
    var context = this;
    var args = arguments;

    if (timeout) clearTimeout(timeout);
    if (immediate) {
      // 如果已经执行过，不再执行
      var callNow = !timeout;
      timeout = setTimeout(function () {
        timeout = null;
      }, wait)
      if (callNow) result = func.apply(context, args)
    } else {
      timeout = setTimeout(function () {
        func.apply(context, args)
      }, wait);
    }
    return result;
  };

  debounced.cancel = function () {
    clearTimeout(timeout);
    timeout = null;
  };

  return debounced;
}
/**
 * 格式化显示一个日期
 * @example ("yyyy-MM-dd hh:mm:ss") ("yyyy年MM月dd日") ("MM/dd/yyyy") ("yyyyMMdd")
 */
export function getNowFormatDate(time, fmt = 'yyyy-MM-dd') {
  var date = new Date();
  if (time) date = time
  // var seperator1 = "-";
  // var seperator2 = ":";
  // var year = date.getFullYear();
  // var month = date.getMonth() + 1;
  // var strDate = date.getDate();
  // if (month >= 1 && month <= 9) {
  //   month = "0" + month;
  // }
  // if (strDate >= 0 && strDate <= 9) {
  //   strDate = "0" + strDate;
  // }
  // var currentdate = year + seperator1 + month + seperator1 + strDate
  // return currentdate;
  var o = {
    "M+": date.getMonth() + 1,                 //月份
    "d+": date.getDate(),                    //日
    "h+": date.getHours(),                   //小时
    "m+": date.getMinutes(),                 //分
    "s+": date.getSeconds(),                 //秒
    "q+": Math.floor((date.getMonth() + 3) / 3), //季度
    "S": date.getMilliseconds()             //毫秒
  };

  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
  }

  for (var k in o) {
    if (new RegExp("(" + k + ")").test(fmt)) {
      fmt = fmt.replace(
        RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
    }
  }

  return fmt;
}

//获取到加减一个天数后新的日期
export function getAddDate(days) {
  var date = new Date();
  date.setDate(date.getDate() + days);
  var seperator1 = "-";
  var seperator2 = ":";
  var year = date.getFullYear();
  var month = date.getMonth() + 1;
  var strDate = date.getDate();
  if (month >= 1 && month <= 9) {
    month = "0" + month;
  }
  if (strDate >= 0 && strDate <= 9) {
    strDate = "0" + strDate;
  }
  var currentdate = year + seperator1 + month + seperator1 + strDate
  return currentdate;
}

//日期选择本周、上周、上上周
export function getDatePickerWeek(n) {
  var now = new Date();
  var year = now.getFullYear();
  //因为月份是从0开始的,所以获取这个月的月份数要加1才行
  var month = now.getMonth() + 1;
  var date = now.getDate();
  var day = now.getDay();
  // console.log(date);
  //判断是否为周日,如果不是的话,就让今天的day-1(例如星期二就是2-1)
  if (day !== 0) {
    n = n + (day - 1);
  } else {
    n = n + 6;
  }
  if (day) {
    //这个判断是为了解决跨年的问题
    if (month > 1) {
      month = month;
    }
    //这个判断是为了解决跨年的问题,月份是从0开始的
    else {
      year = year - 1;
      month = 12;
    }
  }
  now.setDate(now.getDate() - n);
  return now;
}

//日期选择本月、上月、上上月
export function getDatePickerMonth(n, s) {
  let today = new Date();
  let tYear = today.getFullYear();
  let tMonth = today.getMonth() + n;
  let prevDate = new Date(tYear, tMonth, 1);
  if (s) {
    let _date = new Date(tYear, tMonth + 1, 0)
    let _d = _date.getDate()
    prevDate = new Date(tYear, tMonth, _d);
  }
  return prevDate;
}

// 日期选择框快捷方式
export const pickerOptions = {
  shortcuts: [{
    text: '今天',
    onClick(picker) {
      const end = new Date()
      const start = new Date()
      start.setTime(start.getTime())
      picker.$emit('pick', [start, end])
    }
  }, {
    text: '昨天',
    onClick(picker) {
      const start = new Date()
      start.setTime(start.getTime() - 3600 * 1000 * 24)
      picker.$emit('pick', [start, start])
    }
  }, {
    text: '前天',
    onClick(picker) {
      const start = new Date()
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 2)
      picker.$emit('pick', [start, start])
    }
  }, {
    text: '本周',
    onClick(picker) {
      picker.$emit('pick', [getDatePickerWeek(0), getDatePickerWeek(-6)])
    }
  }, {
    text: '上周',
    onClick(picker) {
      picker.$emit('pick', [getDatePickerWeek(7), getDatePickerWeek(1)])
    }
  }, {
    text: '上上周',
    onClick(picker) {
      picker.$emit('pick', [getDatePickerWeek(14), getDatePickerWeek(8)])
    }
  }, {
    text: '本月',
    onClick(picker) {
      picker.$emit('pick', [getDatePickerMonth(0), getDatePickerMonth(0, true)]);
    }
  }, {
    text: '上月',
    onClick(picker) {
      picker.$emit('pick', [getDatePickerMonth(-1), getDatePickerMonth(-1, true)]);
    }
  }, {
    text: '上上月',
    onClick(picker) {
      picker.$emit('pick', [getDatePickerMonth(-2), getDatePickerMonth(-2, true)]);
    }
  }]
}

const modifyDate = function(date, y, m, d) {
  return new Date(y, m, d, date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds());
};

const getDayCountOfMonth = function(year, month) {
  if (month === 3 || month === 5 || month === 8 || month === 10) {
    return 30;
  }

  if (month === 1) {
    if (year % 4 === 0 && year % 100 !== 0 || year % 400 === 0) {
      return 29;
    } else {
      return 28;
    }
  }

  return 31;
};

export const changeYearMonthAndClampDate = function(date, year, month) {
  // clamp date to the number of days in `year`, `month`
  // eg: (2010-1-31, 2010, 2) => 2010-2-28
  const monthDate = Math.min(date.getDate(), getDayCountOfMonth(year, month));
  return modifyDate(date, year, month, monthDate);
};

// 上一个月
export const prevMonth = function(date = new Date()) {
  const year = date.getFullYear();
  const month = date.getMonth();
  return month === 0
    ? changeYearMonthAndClampDate(date, year - 1, 11)
    : changeYearMonthAndClampDate(date, year, month - 1);
};

// 下一个月
export const nextMonth = function(date = new Date()) {
  const year = date.getFullYear();
  const month = date.getMonth();
  return month === 11
    ? changeYearMonthAndClampDate(date, year + 1, 0)
    : changeYearMonthAndClampDate(date, year, month + 1);
};

/*
  判断数据类型
  @param s {Object Number Function Symbol}
  @example toRawType({}) || toRawType([]) || toRawType(true) || toRawType(undefined) || toRawType(null)  || toRawType(function(){})
  @returns Object || Array || Boolean || Undefined || Null || Function
*/
var _toString = Object.prototype.toString;
export const toRawType = (value) => {
  return _toString.call(value).slice(8, -1)
}

/*
  导出
*/
export const exportExcelCommonForVue = (param, columnObj, exportUrl) => {
  let params = {
    param: JSON.stringify(param),
    textList: columnObj.map(item => (item.label)).join(','),
    valueList: columnObj.map(item => (item.prop)).join(',')
  }
  let app = document.querySelector('#app')
  let exportIframe = document.querySelector('#exportIframe')
  console.log(exportIframe)
  if (exportIframe) app.removeChild(exportIframe)
  let iframe = document.createElement("iframe");
  iframe.onload = () => {
    let formData = document.createElement("form");
    formData.setAttribute('method', 'post')
    formData.setAttribute('action', exportUrl)
    for (let name in params) {
      let input = document.createElement("input");
      input.setAttribute('type', 'text')
      input.setAttribute('name', name)
      input.setAttribute('value', params[name])
      console.log(name, params[name])
      formData.appendChild(input);
    }
    console.log(formData)
    let submit = document.createElement("input");
    submit.setAttribute('type', 'submit')
    submit.setAttribute('id', 'submitExportForm')
    formData.appendChild(submit);
    iframe.appendChild(formData);
    let submitExportForm = document.querySelector('#submitExportForm')
    submitExportForm.click();
  }
  iframe.id = 'exportIframe';
  iframe.width = '0';
  iframe.height = '0';
  iframe.src = '/export.html';
  app.appendChild(iframe)
}

// 导出
export const exportExcelCommon = (
  param, // 参数 textList，valueList手动填上后table可不传，否则会自动获取
  exportUrl, // 导出url
  fileName, // 导出的文件名
  table, // entry-table的ref，param中没有表格列信息时，必传
) => {
  try {
    if (table) {
      let tempArr = table.$children.map(item => {
        if (item.prop && item.prop.match(/\//)) {
          let label = item.label.split('/')
          let prop = item.prop.split('/')
          return [
            {
              label: label[0],
              prop: prop[0]
            },
            {
              label: label[1],
              prop: prop[1]
            }
          ]
        } else {
          return {
            label: item.label,
            prop: item.prop
          }
        }
      }).filter(item => (item.prop || Array.isArray(item))).flat()
      param['textList'] = tempArr.map(i => i.label).join(',')
      param['valueList'] = tempArr.map(i => i.prop).join(',')
    }

    newPostBlob(exportUrl, param).then((res) => {
      if (res) {
        const link = document.createElement("a"); // 创建a标签
        let blob = new Blob([res.data], {
          type: "application/vnd.ms-excel;charset=UTF-8",
        }); // 设置文件类型
        link.style.display = "none";
        link.href = URL.createObjectURL(blob); // 将文件流转化为blob地址
        link.setAttribute("download", fileName);//文件名，而不是写死.excel之类
        document.body.appendChild(link);//创建
        link.click();//点击事件
        document.body.removeChild(link);
      }
    })
  } catch (error) {
    console.log(error);
    table.$message.error('导出失败')
  }

}

// 首字母大写
export const titleCase = (str) => {
  return str.replace(/( |^)[a-z]/g, (L) => L.toUpperCase())
}

// 文件下载弹窗
export const fileDownloadLayer = ({ url, title }, callback) => {
  top.layer.open({
    type: 2,
    title,
    shade: 0.4,
    maxmin: true,
    fix: false,
    area: ['680px', '50%'],
    // offset: 'rt',
    content: url,
    cancel: () => {
      if (callback) {
        try {
          // this.$root.onSubmit()
          callback()
        } catch (e) {
          console.log(e)
        }
      }
    }
  });
}
// 打印弹窗
export const printForBillNoLayer = ({ url, title }, callback) => {
  top.layer.open({
    type: 2,
    title,
    shadeClose: true,
    shade: 0.4,
    maxmin: true,
    fix: false,
    area: ['80%', '90%'],
    content: url,
    cancel: () => {
      if (callback) {
        try {
          // this.$root.onSubmit()
          callback()
        } catch (e) {
          console.log(e)
        }
      }
    }
  });
}


//错误导出
export const exportExcelError = (data, exportUrl) => {
  let app = document.querySelector('#app')
  let exportIframe = document.querySelector('#exportIframe')
  console.log(exportIframe)
  if (exportIframe) app.removeChild(exportIframe)
  let iframe = document.createElement("iframe");
  iframe.onload = () => {
    let formData = document.createElement("form");
    formData.setAttribute('method', 'post')
    formData.setAttribute('action', exportUrl)
    for (let name in data) {
      let input = document.createElement("input");
      input.setAttribute('type', 'text')
      input.setAttribute('name', name)
      input.setAttribute('value', data[name])
      console.log(name, data[name])
      formData.appendChild(input);
    }
    console.log(formData)
    let submit = document.createElement("input");
    submit.setAttribute('type', 'submit')
    submit.setAttribute('id', 'submitExportForm')
    formData.appendChild(submit);
    iframe.appendChild(formData);
    let submitExportForm = document.querySelector('#submitExportForm')
    submitExportForm.click();
  }
  iframe.id = 'exportIframe';
  iframe.width = '0';
  iframe.height = '0';
  iframe.src = '/export.html';
  app.appendChild(iframe)
}

// 查询条件处理
export const getQueryItem = (params) => {
  if (toRawType(params) != 'Object') {
    console.log('格式错误', toRawType(params))
    return {}
  }
  console.log(params)
  let tempItem = {}
  Object.values(params).forEach(item => {
    if (item.submitName == 'billDate') {
      tempItem['beginDate'] = item.selected && item.selected.length > 0 ? (item.format ? getNowFormatDate(item.selected[0], item.format) : item.selected[0]) : ''
      tempItem['endDate'] = item.selected && item.selected.length > 0 ? (item.format ? getNowFormatDate(item.selected[1], item.format) : item.selected[1]) : ''
    } else if (item.submitName == 'billTime') {
      tempItem['beginTime'] = item.selected && item.selected.length > 0 ? (item.format ? getNowFormatDate(item.selected[0], item.format) : item.selected[0]) : ''
      tempItem['endTime'] = item.selected && item.selected.length > 0 ? (item.format ? getNowFormatDate(item.selected[1], item.format) : item.selected[1]) : ''
    } else {
      if (toRawType(item.selected) == 'Array') {
        tempItem[item.submitName] = item.selected.map(i => "'" + i.value + "'").join(',') || ''
      } else if (toRawType(item.selected) == 'String') {
        tempItem[item.submitName] = item.selected || ''
      } else if (toRawType(item.selected) == 'Object') {
        tempItem[item.submitName] = item.selected.value || ''
      } else if (toRawType(item.selected) == 'Null') {
        tempItem[item.submitName] = ''
      }
    }
  })
  return tempItem
}

export function loadJs(src) {
  return new Promise((resolve, reject) => {
    let script = document.createElement('script');
    script.type = "text/javascript";
    script.src = src;
    document.body.appendChild(script);

    script.onload = () => {
      resolve();
    }
    script.onerror = () => {
      reject();
    }
  })
}
